module.exports = __webpack_public_path__ + "static/media/logo.ab1a6759.png";